module.exports = __webpack_public_path__ + "img/12.103f11ba.png";